// extracted by mini-css-extract-plugin
export var closeButton = "_l5-2";
export var closeButtonIcon = "_l5-3";
export var lightboxContent = "_l5-1";
export var lightboxOverlay = "_l5-0";